import { TFunction } from '@bonanza-social/i18n';
import { RadioOption } from '@bonanza-social/moonlight';

export function getCloseAccountOptions(t: TFunction): RadioOption[] {
  return [
    {
      locNS: 'account',
      locKey: 'myProfileCloseAccountReasonPromotions',
      value: t('myProfileCloseAccountReasonPromotions'),
    },
    {
      locNS: 'account',
      locKey: 'myProfileCloseAccountReasonGames',
      value: t('myProfileCloseAccountReasonGames'),
    },
    {
      locNS: 'account',
      locKey: 'myProfileCloseAccountReasonSupport',
      value: t('myProfileCloseAccountReasonSupport'),
    },
    {
      locNS: 'account',
      locKey: 'myProfileCloseAccountReasonTakingBreak',
      value: t('myProfileCloseAccountReasonTakingBreak'),
    },
    {
      locNS: 'account',
      locKey: 'myProfileCloseAccountReasonOther',
      value: t('myProfileCloseAccountReasonOther'),
    },
  ];
}
